import React from 'react';
import CoreMovedAlert from "v4/components/admin/CoreMovedAlert/CoreMovedAlert";

export default function Tabs() {
    return <CoreMovedAlert corePath="admin/tabs"/>
}
